module.exports = __webpack_public_path__ + "img/Illustrasi.8ace8293.svg";